var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 700,
    height: 1000,
    viewBox: "31.67 0 700 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 350 500)",
    id: "a54df2ad-b812-45a5-bdd1-be82ecd44904"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#ff8d2f",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -350,
    y: -500,
    rx: 0,
    ry: 0,
    width: 700,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "ea198902-2f8a-4f17-b080-ec23877a4447"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.95 0 0 0.95 381.44 500)",
    id: "88b227a9-ba5b-4ef1-93d9-07b75c1a39b6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#ff8d2f",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-512, -512)",
    d: "M 512 85.333333 C 347.050667 85.333333 213.33333299999998 219.072 213.33333299999998 384 C 213.33333299999998 548.949333 512 938.666667 512 938.666667 C 512 938.666667 810.666667 548.9493339999999 810.666667 384 C 810.666667 219.072 676.9493339999999 85.33333299999998 511.99999999999994 85.33333299999998 z M 512 533.333333 C 429.5254775426964 533.333333 362.66666699999996 466.4745224573036 362.66666699999996 384 C 362.66666699999996 301.5254775426965 429.5254775426964 234.66666700000002 512 234.66666700000002 C 594.4745224573036 234.66666700000002 661.333333 301.5254775426964 661.333333 384 C 661.333333 466.4745224573036 594.4745224573036 533.333333 512 533.333333 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.bb03ccd002f89a1d6d41115207c8f8cc.svg";
export { ForwardRef as ReactComponent };